import React from 'react'
import PropTypes from 'prop-types'
import { P103_2B, P104_3, P105_3, P106_3, P107_2 } from 'rpqs/constants/RpqsConstant'
import DialogP106_3 from './DialogP106_3'
import DialogP105_3 from './DialogP105.3'
import DialogP107_2 from './DialogP107_2'
import DialogP103_2B from './DialogP103_2B'
import DialogP104_3 from './DialogP104_3'

const NetworkDialog = ({
    open = false,
    setOpen = () => {},
    codeIndicator = '',
    dialogTitle = '',
}) => {
    return (
        <>
            {codeIndicator === P106_3.code && <DialogP106_3/>}
            {codeIndicator === P104_3.code &&
                <DialogP104_3
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P105_3.code &&
                <DialogP105_3
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P107_2.code &&
                <DialogP107_2
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P103_2B.code &&
                <DialogP103_2B
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
        </>
    )
}

NetworkDialog.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    codeIndicator: PropTypes.string,
    dialogTitle: PropTypes.string,
}

export default NetworkDialog